import React from 'react';
import PropTypes from 'prop-types';

import UCD604Logo from '../../../../images/UCD604Logo.png';
import { reverseFormatDate } from '../../../../utils/dateFunctions';

import local from './ucd604Form.module.css';

const UCD604FormTemplate = ({ surveyAnswers }) => {

    return (
        <div className={local.templateWrapper}>
            <div className={local.logo}>
                <img src={UCD604Logo} alt="UCD604 Form Logo" />
            </div>

            <div className={local.disclaimer}>
                Please note that this form may be shown to the participant
            </div>

            <div className={local.heading}>About the participant</div>
            <div className={local.ptDetails}>
                <div className={local.row}>
                    <span className={local.label}>Participant&apos;s Name:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_1}</span>
                </div>
                <div className={local.row}>
                    <span className={local.label}>Participant&apos;s NINO:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_2}</span>
                </div>
            </div>

            <div className={local.heading}>Details</div>
            <div className={local.details}>
                <div className={local.label}>
                    UC participant had a sanction applied for not meeting the requirement set by the
                    provider. <br /> I am now requesting that this decision be reviewed for the
                    following reason:
                </div>
                <div className={local.row}>
                    <span className={local.description}>Participant has now fully complied:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_3}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>
                        It is no longer appropriate for the participant to undertake that activity:
                    </span>
                    <span className={local.answerBox}>{surveyAnswers.Q_4}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>
                        Participant has fully complied with the alternative activity notified on the
                        UC193:
                    </span>
                    <span className={local.answerBox}>{surveyAnswers.Q_5}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>
                        I consider that the participant has not fully complied
                        <span>(complete &apos;compliance dispute&apos; section below):</span>
                    </span>
                    <span className={local.answerBox}>{surveyAnswers.Q_6}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>
                        Date they failed to undertake the original Mandatory Activity:
                    </span>
                    <span className={local.dateBox}>{surveyAnswers.Q_7}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>
                        Date of compliance or activity no longer applicable:
                    </span>
                    <span className={local.dateBox}>{surveyAnswers.Q_8}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Date of sanction decision (if known):</span>
                    <span className={local.smallDateBox}>{surveyAnswers.Q_9}</span>
                    <span className={local.description}>
                        Dates of sanction (if known) <span>From:</span>
                    </span>
                    <span className={local.smallDateBox}>{surveyAnswers.Q_10}</span>
                </div>
                <div className={`${local.row} ${local.compactRow}`}>
                    <span className={local.description}>
                        <span>To</span> (if known)
                    </span>
                    <span className={local.smallDateBox}>{surveyAnswers.Q_11}</span>
                </div>
            </div>

            <div className={local.heading}>Compliance disputed</div>
            <div className={local.disputed}>
                <div className={`${local.section} ${local.firstSection}`}>
                    <div className={local.label}>
                        A. What was the participant told to do and when?
                    </div>
                    <div className={local.largeAnswerBox}>{surveyAnswers.Q_12}</div>
                </div>
                <div className={local.page1End}></div>

                <div className={local.section}>
                    <div className={local.label}>
                        B. What did the participant fail to do and when?
                    </div>
                    <div className={local.largeAnswerBox}>{surveyAnswers.Q_13}</div>
                </div>
                <div className={local.section}>
                    <div className={local.label}>
                        C. Why do you consider that the participant has failed to complete the
                        activity?
                    </div>
                    <div className={local.largeAnswerBox}>{surveyAnswers.Q_14}</div>
                </div>
                <div className={local.section}>
                    <div className={local.label}>
                        D. Why does the participant consider that they have completed the activity?
                    </div>
                    <div className={local.largeAnswerBox}>{surveyAnswers.Q_15}</div>
                </div>
            </div>

            <div className={local.heading}>Provider details</div>
            <div className={local.providerDetails}>
                <div className={local.firstRow}>
                    <span className={local.label}>
                        I confirm that the above is a full and accurate statement
                    </span>
                    <span className={local.answerBox}>{surveyAnswers.Q_16 === 'Yes' && 'X'}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Name of adviser/tutor:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_17}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Email address:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_18}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Name of Provider:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_19}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Provider Address (correspondence):</span>
                    <span className={`${local.answerBox} ${local.address}`}>
                        {surveyAnswers.Q_20}
                    </span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Date:</span>
                    <span className={local.answerBox}>{reverseFormatDate(surveyAnswers.Q_21)}</span>
                </div>
                <div className={local.row}>
                    <span className={local.description}>Phone:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_22}</span>
                </div>
            </div>

            <div className={local.heading}>Subcontractors only</div>
            <div className={local.subContractorDetail}>
                <div className={local.row}>
                    <span className={local.label}>Prime Provider Name:</span>
                    <span className={local.answerBox}>{surveyAnswers.Q_23}</span>
                </div>
                <div className={local.row}>
                    <span className={local.formName}>UC604_vRestart</span>
                </div>
            </div>
        </div>
    );
};

UCD604FormTemplate.propTypes = {
    surveyAnswers: PropTypes.object.isRequired
};

export default UCD604FormTemplate;
